/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ChangeCadenceRequestCadence } from './changeCadenceRequestCadence';

export interface ChangeCadenceRequest {
  cadence: ChangeCadenceRequestCadence;
  seat_count?: number | null;
}
